export const name = 'document';

export const Document = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 2.25C3 1.83579 3.33579 1.5 3.75 1.5H9H10.9622C11.1475 1.5 11.3262 1.56858 11.4639 1.69253L14.7517 4.65155C14.9098 4.79378 15 4.99641 15 5.20902V9V15.75C15 16.1642 14.6642 16.5 14.25 16.5H3.75C3.33579 16.5 3 16.1642 3 15.75V2.25Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M11.25 1.5V4.6875C11.25 5.10171 11.5858 5.4375 12 5.4375H15"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M6 5.4375H8.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
    <path
      d="M6 9H12"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
    <path
      d="M6 12.75H12"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </svg>
);
